import { useMutation } from '@tanstack/react-query';
import { useServicesContext } from '../../contexts/ServicesContext';
import { ArticleDraftRequest } from '../../api/queries';

enum CacheKey {
  updateDraftArticle = 'updateDraftArticle',
}

export const useUpdateDraftArticleMutation = () => {
  const { updateDraftArticle } = useServicesContext();

  return useMutation({
    mutationKey: [CacheKey.updateDraftArticle],
    mutationFn: ({
      draftId,
      draftArticle,
    }: {
      draftId: number;
      draftArticle: Partial<ArticleDraftRequest>;
    }) => updateDraftArticle({ draftId, draftArticle }),
  });
};
